import { ATS_API_URL, OLD_DOCUPLOAD_API } from "../../config";
import baseDataProvider, { httpClient } from "../baseDataProvider";
import { stringify } from "query-string";
const API_URL = ATS_API_URL;
const API_URL_DOC = `${API_URL}/applicant`;

const normalizeApplicationFraudRisk = (value: unknown): boolean | null => {
    if (value === true) {
        return true;
    }

    if (value === false) {
        return false;
    }

    return null;
};
const getMany = async (resource, params) => {
    if (resource === "applicationFraudFlags") {
      try {
        const { json }: any = await httpClient(
          API_URL_DOC + `/riskIndicator/getApplicationFraudFlags`,
          {
            method: "POST",
            body: JSON.stringify({
              applicationIds: params.ids,
            }),
          }
        );

        const requestedIds: string[] = Array.from(
          new Set((params?.ids || []).map((id: string | number) => String(id)))
        );
        const responseByApplicationId = new Map<string, any>();
        for (const record of json?.records?.success || []) {
          const applicationId = String(record.applicationId || record.id || "");
          if (applicationId) {
            responseByApplicationId.set(applicationId, record);
          }
        }

        return {
          data: requestedIds.map((applicationId: string) => {
            const record = responseByApplicationId.get(applicationId);
            return {
              id: applicationId,
              applicationId,
              hasFraudRisk: record ? normalizeApplicationFraudRisk(record.hasFraudRisk) : null,
            };
          }),
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "incomeMany") {
      try {
        const { json, headers, status }: any = await httpClient(
          API_URL_DOC + `/income/incomeMany?trnIds=${params.ids.join("&trnIds=")}`,
        );
        const response = json.records.success.map(record => ({
          ...record,
          employment_details: {
            ...record.employment_details,
            employer: record.employment_details.employer.map((emp: any) => ({
              ...emp,
              files: emp.files.map(file => ({
                ...file,
                Pay_date: file?.Pay_date?.split("T").shift(),
                End_date: file?.End_date?.split("T").shift(),
                Start_date: file?.Start_date?.split("T").shift(),
                Pay_frequency: {
                  value: file.Pay_frequency,
                  label: file.Pay_frequency,
                },
              }))
            }))
          },
        }));

        return { data: response || [] };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "mlclassfile") {
      try {
        const { status, headers, body, json }: any = await httpClient(
          `${API_URL_DOC}/ml/mlclassdetails?ids=${params.ids.join("&ids=")}`,
          { method: "GET" }
        );
        const res = json;
        return { data: res, total: headers.get("X-Total-Count") };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (
      resource === "getAllBlockSections" ||
      resource === "getAllColumnSections"
    ) {
      try {
        const query = {
          filter: JSON.stringify({ id: params.ids }),
        };
        const { json }: any = await httpClient(
          API_URL_DOC + `/ml/${resource}?${stringify(query)}`,
          {
            method: "GET",
          }
        );
        const r = json;
        const res = {
          data: [...r.records],
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getAllFieldsByDocumentId") {
      try {
        const { json }: any = await httpClient(
          API_URL_DOC + `/ml/getAllFieldsByDocumentId/6`,
          {
            method: "GET",
          }
        );
        const r = json;
        const res = {
          data: [...r.records],
          total: r.records.length,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    return baseDataProvider.getMany(resource, params);
  }

export default getMany;
